<crm-single-select
  #singleSelectComponent
  [options]="accountingAccounts"
  [(selectedItem)]="_selectedAccountingAccount"
  (selectedItemChange)="onSelect($event)"
  [label]="labelInput ? 'Бух. счет' : ''"
  [disabled]="disabled"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [virtualScroll]="true"
  [virtualScrollItemSize]="35"
  [isTemplateCombined]="true"
  (onShow)="onShowPanel()"
  (onFilter)="search($event.filter)"
  [appendTo]="appendTo"
  filterBy="name,code"
  [showClear]="showClear">
  <ng-template
    #itemTemplate
    let-item="item">
    <div *ngIf="toItem(item) as item">
      <p>
        <span [innerHTML]="highlightMatchText(item.name) | safeHtml"></span>
      </p>
      <p class="frm-color-green text-sm">{{ item.code }}</p>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
